import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { GenesysUserPermissionService } from 'common/store/genesys-cloud/users/services/user-permission.service';
import { UserPermission } from 'common/store/genesys-cloud/users/models/user-permission.enum';
import { UserHasPermissionDirectiveBase } from './user-has-permission-directive-base';
import { PermissionMatchMode } from '../models/permission-match-mode.model';

@Directive({
  selector: `[gcUserHasAllPermissions]`
})
export class UserHasAllPermissionsDirective extends UserHasPermissionDirectiveBase {

  constructor(readonly templateRef: TemplateRef<any>,
              readonly viewContainer: ViewContainerRef,
              readonly permissionService: GenesysUserPermissionService) {
    super(templateRef, viewContainer, permissionService);
  }

  @Input()
  set gcUserHasAllPermissions(permissions: UserPermission | UserPermission[]) {
    this.setPermissions(permissions);
  }

  protected get matchMode(): PermissionMatchMode {
    return 'all';
  }
}
